/**
 * Created by Jie Gao on 2017-05-18.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite} from "gsap";
import {WixxGameConfig} from "../WixxGameConfig";
import {WixxSoundConfig} from "../WixxSoundConfig";
import {WixxForegroundRespinView} from "./WixxForegroundRespinView";

export class WixxForegroundRespinController extends BaseController {

    private _view:WixxForegroundRespinView;
    private _timeline:TimelineLite;
    private _isNextRespin:boolean;
    private _respinStarted:boolean;

    constructor() {
        super();
        this._respinStarted = false;
        this._view = new WixxForegroundRespinView(StageManager.getLayer(WixxGameConfig.instance.LAYERS.FOREGROUND_RESPIN.name));
        this.addEventListeners();
    }

    private addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));

        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.onSpinStart());
        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event:GameEvent) => this.onAllReelsSpinStopped());
    }

    private onGameDataParsed(data:ParsedServerData):void {
        this._isNextRespin = data.nextMode === GameMode.RESPIN;
    }

    protected onSpinStart():void {
        if(!this._isNextRespin) {
            return;
        }

        if(this._timeline == null) {
            const timeline = new TimelineLite();
            timeline.add(() => this._view.playAnimation(), "0");
            timeline.add(() => {
                if(WixxSoundConfig.instance.RESPIN_MUSIC != null) {
                    SlotGame.sound.fadeAmbience(1, 0);
                    SlotGame.sound.playAmbience(WixxSoundConfig.instance.RESPIN_MUSIC);
                }
            }, "+=0.3");
            this._timeline = timeline;
        }

        this._timeline.timeScale(1);
        this._timeline.play(0);
        this._respinStarted = true;
    }

    private onAllReelsSpinStopped():void {
        // #107 Fade out music before respin
        //    if(WixxSoundConfig.instance.MAIN_GAME_AMBIANCE != null) {
        //        SlotGame.sound.fadeAmbience( 0, 0);
        //    }

        if(this._respinStarted) {
            if(WixxSoundConfig.instance.MAIN_GAME_AMBIANCE != null) {
                SlotGame.sound.playAmbience(WixxSoundConfig.instance.MAIN_GAME_AMBIANCE);
            }
            if(WixxSoundConfig.instance.RESPIN_MUSIC_END != null) {
                SlotGame.sound.playEffect(WixxSoundConfig.instance.RESPIN_MUSIC_END);
            }

            if(this._timeline && this._timeline.isActive()) {
                this._timeline.timeScale(5);
            }
        }

        this._respinStarted = false;
    }
}